"use client"

import { type BygdekinoenLocation } from "@/sanity/sanity.types";
import storage from 'local-storage-fallback';
import { type ActionDispatch, createContext } from "react";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const LocationContext = createContext<LocationStateWithDispatcher>({ selected: [], isShowingLocationTools: false, dispatcher: (action: Actions) => { } });

export type LocationState = {
    selected: BygdekinoenLocation[];
    isShowingLocationTools: boolean;
    replaced?: boolean;

};

type LocationStateWithDispatcher = LocationState & {
    dispatcher: ActionDispatch<[action: Actions]>;
};

export type AddLocationAction = {
    type: "addLocation";
    value: BygdekinoenLocation;
}

export type RemoveLocationAction = {
    type: "removeLocation";
    value: BygdekinoenLocation;
}

export type ReplaceLocationsAction = {
    type: "replace";
    value: BygdekinoenLocation[];
    save?: boolean;
    replaced?: boolean;
}

export type ToggleToolsDisplay = {
    type: "toggleToolsDisplay";
    value: boolean;
}

export type Actions = AddLocationAction | RemoveLocationAction | ReplaceLocationsAction | ToggleToolsDisplay;

export function locationInitializer(defaultState: LocationState) {
    const bkLoc = storage.getItem("bk_loc");
    if (bkLoc) {
        return { selected: JSON.parse(bkLoc) as BygdekinoenLocation[] };
    }
    return defaultState;
}

export function locationReducer(state: LocationState, action: Actions): LocationState {
    let newState = state;
    switch (action.type) {
        case "addLocation":
            newState = { ...state, selected: sortTheaters([...(state.selected.filter(t => t.teaternr !== action.value.teaternr)), action.value]) };
            storage.setItem("bk_loc", JSON.stringify(newState.selected));
            window?.scrollTo({ top: 0, behavior: "smooth" });
            break;
        case "removeLocation":
            newState = { ...state, selected: state.selected.filter(t => t.teaternr !== action.value.teaternr) };
            storage.setItem("bk_loc", JSON.stringify(newState.selected));
            break;
        case "replace":
            console.debug("ACTION", action);
            newState = { ...state, selected: action.value };
            if (action.replaced) {
                newState.replaced = true;
            }
            if (action.save) {
                storage.setItem("bk_loc", JSON.stringify(action.value));
            }
            break;
        case "toggleToolsDisplay":
            newState = { ...state, isShowingLocationTools: action.value };
    }


    return newState;
}

function sortTheaters(theaters: BygdekinoenLocation[]): BygdekinoenLocation[] {
    return [...theaters].sort((t1: BygdekinoenLocation, t2: BygdekinoenLocation) => t1.poststed.localeCompare(t2.poststed, "no"))
}